// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, OnInit } from '@angular/core';
import { takeWhile } from 'rxjs';
import { DealershipService } from '../../services/dealership.service';
import { removeNonNumericCharacters } from '../../utils/utils';
import { SettingsService } from '@services/settings.service';

@Component({
    selector: 'need-help-panel',
    templateUrl: './need-help-panel.component.html',
    styleUrls: ['./need-help-panel.component.scss'],
})
export class NeedHelpPanelComponent implements OnInit {
    isPanelOpen = false;
    supportEmail: string;
    tenantSupportPhone = '';
    tenantSupportPhoneUnformatted = '';
    tabText: string;
    private isComponentAlive = true;

    constructor(
        private readonly dealershipService: DealershipService,
        private readonly settingsService: SettingsService
    ) {}

    ngOnInit(): void {
        if (
            window.location.href.includes('/leads') ||
            window.location.href.includes('/documents') ||
            window.location.href.includes('/storage') ||
            window.location.href.includes('/dealerManagement') ||
            window.location.href.includes('/userManagement') ||
            window.location.href.includes('/custom') ||
            window.location.href.includes('/create') ||
            window.location.href.includes('/express-upload') ||
            window.location.href.includes('/forms') ||
            window.location.href.includes('/deals')
        ) {
            this.tabText = 'Learn More';
        } else if (window.location.href.includes('/express')) {
            this.tabText = 'Show Me How';
        } else {
            this.tabText = 'Need Help?';
        }

        this.dealershipService.dealer$.pipe(takeWhile(() => this.isComponentAlive)).subscribe(async (dealer) => {
            ({ supportEmail: this.supportEmail, supportPhone: this.tenantSupportPhone } = await this.settingsService.getOemSettings(dealer.oemCode));
            this.tenantSupportPhoneUnformatted = removeNonNumericCharacters(this.tenantSupportPhone);
        });
    }

    openHelpPanel() {
        this.isPanelOpen = true;
    }

    closeHelpPanel() {
        this.isPanelOpen = false;
    }
}
